import * as ui from '../../ui/index.js';

/**
 * Loader for the PopupTour module
 * 
 * @author rhess <robin.hess@awi.de>
 */

/**
 * A function that loads the PopupTour
 * 
 * @memberof vef.viewer.loader
 * 
 * @param {object} options 
 * @param {Viewer} viewer 
 */
export function PopupTour(options, viewer) {
    const popupTour = new ui.PopupTour(null, options.items);
    popupTour.on("append", () => popupTour.open());

    viewer.addElement(options.id, popupTour);
}
